import React, { useMemo } from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';

import { useSearchParams } from 'hooks';
import { Button, Text, Title } from 'components';

import {
  CardProgress,
  CenterTextWrapper,
  SVGParty,
  VerticalSpace,
} from '@brokerbay/design-components';

import { WizardType } from '../../types';

const SVGPartyStyled = styled(SVGParty)`
  width: 100%;
`;

export type GetStartedViewProps = RouteComponentProps<{ hash?: string }> & {
  type: WizardType;
  setIsUnclaimedApprover?: (val: boolean) => void;
  handleGoNextStep: () => void;
};

export const GetStartedView = (props: GetStartedViewProps) => {
  const { handleGoNextStep, type, setIsUnclaimedApprover } = props;
  const { approver } = useSearchParams();

  if (type === 'user' && setIsUnclaimedApprover) {
    // Set in ctx whether user claim flow should end in the 'Approval Submitted!' success screen
    const isUnclaimedApprover = approver === 'true';
    setIsUnclaimedApprover(isUnclaimedApprover);
  }

  const onboardingTypeLabel = useMemo(() => {
    switch (type) {
      case 'user':
        return 'account';
      case 'org':
        return 'brokerage';
      default:
        throw new Error(`Invalid Onboarding type: ${type}`);
    }
  }, [type]);

  return (
    <VerticalSpace>
      <SVGPartyStyled />

      <Title textAlign="center" level={3} data-cy="title-setup">
        Setup your {onboardingTypeLabel} on BrokerBay
      </Title>
      <CenterTextWrapper>
        <Text>Let&apos;s get started!</Text>
      </CenterTextWrapper>

      <Button
        block
        type="primary"
        htmlType="button"
        onClick={handleGoNextStep}
        data-cy="button-next-step"
      >
        Next
      </Button>

      <CardProgress percent={(1 / 5) * 100} />
    </VerticalSpace>
  );
};
